import { render, staticRenderFns } from "./index.html?vue&type=template&id=38ab4922&"
import script from "./searchStudent.vue?vue&type=script&lang=js&"
export * from "./searchStudent.vue?vue&type=script&lang=js&"
import style0 from "./searchStudent.vue?vue&type=style&index=0&id=38ab4922&prod&lang=css&"
import style1 from "./searchStudent.vue?vue&type=style&index=1&id=38ab4922&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports